import React, {useEffect} from 'react';
import useCommonAPI from "../../api/CommonAPI";
import {capitalizeFirstLetters} from "../../features/ValueFormater";

function EmployeesInput({data, setData}) {

    const {roles, getAllEmployeesRoles,} = useCommonAPI();

    useEffect(() => {
        getAllEmployeesRoles();
    }, []);

    function handleAdd() {
        setData([...data, {MobileNo: '', AccessLevel: ''}]);
    }

    function handleRemove(index) {
        setData(data.filter((supervisor, i) => i !== index));
    }


    function handleInputChange(event, index, key) {
        const {value} = event.target;
        setData(
            data.map((row, i) =>
                i === index ? {...row, [key]: value} : row
            )
        );
    }


    return (
        <div className="employees-input">
            <div className="row">
                <div className='row'>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row title-supervisor">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Phone Number</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="row title-supervisor">
                            <div className="col-lg-12 col-md-12 col-sm-12 subTitle">Access</div>
                        </div>
                    </div>
                </div>
            </div>


            {data.length !== 0 && data.map((item, index) => (
                <div className="row pt-2" key={index}>
                    <div className='row'>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <input
                                            placeholder="Xxx"
                                            value={item.MobileNo}
                                            onChange={(event) => handleInputChange(event, index, 'MobileNo')}
                                            disabled={index === 0}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="row component">
                                    <div className="col-lg-12 col-md-12 col-sm-12 desc">
                                        <select
                                            placeholder="Name"
                                            value={item.AccessLevel}
                                            onChange={(event) => handleInputChange(event, index, 'AccessLevel')}
                                            disabled={index === 0}
                                        >
                                            <option value="">Select</option>
                                            {roles && roles[1]?.Roles?.map((role) => (
                                                <option key={role.RoleID} value={role.Name}>
                                                    {capitalizeFirstLetters(role.Name)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>


                        {index > 0 && (
                            <div className="col-1">
                                <div className="row component">
                                    <div className="col-12 subTitle">
                                        <button className='removeTill' onClick={() => handleRemove(index)}>
                                            <img src="/Images/remove-till.png"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
            <div className='row'>
                <div className={"col-lg-6 col-md-6 col-sm-12"}>
                    <div className="row component">
                        <div className="col-12 subTitle">
                            <button className='addTill' onClick={handleAdd}>
                                + ADD ANOTHER EMPLOYEE
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default EmployeesInput;
